var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVostochniy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vostochniy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 444706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.22222 6.75C1.02222 6.35 0.922222 5.9 1.07222 5.5C1.17222 5.05 1.47222 4.7 1.82222 4.5L9.32222 0.15C9.52222 0.05 9.62222 0 9.77222 0C9.92222 0 10.0722 0.05 10.1722 0.1L17.6722 4.45C17.8722 4.55 18.0722 4.7 18.2222 4.85C18.3722 5 18.4722 5.25 18.5222 5.45C18.5722 5.65 18.6222 5.9 18.5722 6.1C18.5222 6.35 18.4722 6.55 18.3722 6.75C18.2722 6.95 18.1222 7.1 17.9222 7.25C17.7222 7.4 17.5222 7.5 17.3222 7.55C17.1222 7.6 16.8722 7.6 16.6722 7.55C16.4722 7.5 16.2222 7.45 16.0222 7.3L9.77222 3.7L3.52222 7.35C3.12222 7.55 2.67222 7.65 2.27222 7.5C1.82222 7.4 1.47222 7.1 1.22222 6.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.8222 9.15002H2.72224C2.62224 9.15002 2.52224 9.15002 2.42224 9.20002C2.32224 9.25002 2.22224 9.30002 2.17224 9.40002C2.07224 9.50002 2.02224 9.55002 1.97224 9.70002C1.92224 9.80002 1.92224 9.90002 1.92224 10V18.1C1.92224 18.6 2.12224 19.1 2.47224 19.45C2.82224 19.8 3.27224 20 3.77224 20C4.27224 20 4.77224 19.8 5.12224 19.45C5.47224 19.1 5.67224 18.6 5.67224 18.1V12.5H7.92224V18.1C7.92224 18.6 8.12224 19.1 8.47224 19.45C8.82224 19.8 9.32224 20 9.82224 20C10.3222 20 10.8222 19.8 11.1722 19.45C11.5222 19.1 11.7222 18.6 11.7222 18.1V12.5H13.9722V18.1C13.9722 18.6 14.1722 19.1 14.5222 19.45C14.8722 19.8 15.3722 20 15.8722 20C16.3722 20 16.8722 19.8 17.2222 19.45C17.5722 19.1 17.7722 18.6 17.7722 18.1V10C17.7722 9.80002 17.6722 9.55002 17.5222 9.40002C17.3722 9.25002 17.0722 9.15002 16.8222 9.15002Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVostochniy);
export default __webpack_public_path__ + "static/media/vostochniy.0c0a9e9d712dcb3b0f0321a4247fc69b.svg";
export { ForwardRef as ReactComponent };